var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.5C5.5 0.947715 5.05228 0.5 4.5 0.5C3.94772 0.5 3.5 0.947715 3.5 1.5V2.5H2.5C1.39572 2.5 0.5 3.39572 0.5 4.5V15.5C0.5 16.6043 1.39572 17.5 2.5 17.5H14.5C15.6043 17.5 16.5 16.6043 16.5 15.5V4.5C16.5 3.39572 15.6043 2.5 14.5 2.5H13.5V1.5C13.5 0.947715 13.0523 0.5 12.5 0.5C11.9477 0.5 11.5 0.947715 11.5 1.5V2.5H9.5V1.5C9.5 0.947715 9.05229 0.5 8.5 0.5C7.94772 0.5 7.5 0.947715 7.5 1.5V2.5H5.5V1.5ZM2.5 4.5V5.5H14.5V4.5H2.5ZM14.5 15.5V7.5H2.5V15.5H14.5Z",
    fill: "#797E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.4acf555cd6f402709d35f00ecc26e821.svg";
export { ForwardRef as ReactComponent };